import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function AllAdmins() {
  const [admins, setAdmins] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = () => {
    axios
      .get("https://missionmap-lc.onrender.com/api/admin/all-admins")
      .then((res) => setAdmins(res.data))
      .catch((err) => console.error(err));
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete this admin.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`https://missionmap-lc.onrender.com/api/admin/${id}`)
          .then(() => {
            Swal.fire("Deleted!", "Admin has been deleted.", "success");
            fetchAdmins();
          })
          .catch((err) => console.error(err));
      }
    });
  };

  const handleEdit = (admin) => {
    Swal.fire({
      title: "Edit Admin",
      html: `
      <div style="position: relative; width: 100px; height: 100px; margin: auto;">
        <img id="profilePreview" src="{admin.profileImage || 'default.png'}" 
          alt="Profile" 
          style="width: 100px; height: 100px; object-fit: cover; border-radius: 50%; border: 3px solid #d6b4fc;" 
        />
        <input type="file" id="profileImage" accept="image/*" style="display: none;" />
        <div onclick="document.getElementById('profileImage').click()" 
          style="
            position: absolute;
            bottom: -5px;
            right: -5px;
            background: white;
            border-radius: 50%;
            padding: 6px;
            box-shadow: 0 0 5px rgba(0,0,0,0.2);
            cursor: pointer;
          ">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#a855f7" style="width: 16px; height: 16px;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5l-1.5 1.5 1.5 1.5m-7.5-3l1.5 1.5-1.5 1.5M12 3v1.5m0 15V21m8.25-9h-1.5m-15 0H3m2.25 6.75l1.06-1.06m12.38 0l-1.06-1.06m0-12.38l1.06 1.06M6.31 6.31L5.25 5.25" />
          </svg>
        </div>
      </div>
        
        <input type="text" id="username" class="swal2-input" value="${admin.username}" placeholder="Username" />
        <input type="email" id="email" class="swal2-input" value="${admin.email}" placeholder="Email" />
        <input type="text" id="company" class="swal2-input" value="${admin.company}" placeholder="Company" />
        <input type="password" id="password" class="swal2-input" value="${admin.password}" placeholder="New Password" />
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Update",
      preConfirm: () => {
        const fileInput = document.getElementById("profileImage");
        const username = document.getElementById("username").value;
        const email = document.getElementById("email").value;
        const company = document.getElementById("company").value;
        const password = document.getElementById("password").value;

        const formData = new FormData();
        formData.append("username", username);
        formData.append("email", email);
        formData.append("company", company);
        if (password) formData.append("password", password);
        if (fileInput.files.length > 0) {
          formData.append("profileImage", fileInput.files[0]);
        }

        return { id: admin._id, formData };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Are you sure?",
          text: "You are about to update this admin.",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes, update",
        }).then((confirmResult) => {
          if (confirmResult.isConfirmed) {
            axios
              .put(
                `https://missionmap-lc.onrender.com/api/admin/${result.value.id}`,
                result.value.formData
              )
              .then(() => {
                Swal.fire("Updated!", "Admin has been updated.", "success");
                fetchAdmins();
              })
              .catch((err) => console.error(err));
          }
        });
      }
    });
  };

  return (
    <div className="p-5 bg-purple-100 min-h-screen">
            <button
        type="button"
        onClick={() => navigate(-1)}
        className="absolute top-4 left-4 flex items-center gap-2 text-purple-600 hover:text-purple-800 font-medium"
      >
        ← Back
      </button>
      <div className="flex justify-between items-center max-w-5xl mx-auto mb-6 mt-6">
        <h2 className="text-purple-700 font-bold text-2xl md:text-4xl">
          Register Admins
        </h2>
        <button
          onClick={() => navigate("/signup")}
          className="px-4 py-2 rounded-lg bg-gradient-to-r from-purple-500 to-pink-500 text-white font-medium hover:opacity-90 transition"
        >
          Signup
        </button>
      </div>

      <div className="bg-white rounded-2xl shadow-lg overflow-hidden max-w-5xl mx-auto">
        <div className="overflow-x-auto max-h-[500px] overflow-y-auto">
          <table className="w-full border-collapse">
            <thead className="bg-purple-100 sticky top-0 z-10">
              <tr>
                <th className="py-3 px-4 text-purple-700 font-bold text-left">Profile</th>
                <th className="py-3 px-4 text-purple-700 font-bold text-left">Username</th>
                <th className="py-3 px-4 text-purple-700 font-bold text-left">Email</th>
                <th className="py-3 px-4 text-purple-700 font-bold text-left">Company</th>
                <th className="py-3 px-4 text-purple-700 font-bold text-left">Password</th>
                <th className="py-3 px-4 text-purple-700 font-bold text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {admins.map((admin) => (
                <tr key={admin._id} className="border-b border-gray-100">
                  <td className="py-3 px-4">
                    {admin.profileImage ? (
                      <img
                        src={admin.profileImage}
                        alt={admin.username}
                        className="w-10 h-10 rounded-full object-cover"
                      />
                    ) : (
                      <span className="text-gray-500">No Image</span>
                    )}
                  </td>
                  <td className="py-3 px-4 text-gray-700">{admin.username}</td>
                  <td className="py-3 px-4 text-gray-700">{admin.email}</td>
                  <td className="py-3 px-4 text-gray-700">{admin.company}</td>
                  <td className="py-3 px-4 text-gray-700">{admin.password}</td>
                  <td className="py-3 px-4 pt-6 flex gap-3">
                    <FaEdit
                      className="cursor-pointer text-blue-600 hover:text-blue-800"
                      onClick={() => handleEdit(admin)}
                    />
                    <FaTrash
                      className="cursor-pointer text-red-500 hover:text-red-700"
                      onClick={() => handleDelete(admin._id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
